import { Page } from '@hubspot/api-client/lib/codegen/cms/pages';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { HubspotPagePage, QueryHubspotIntegrationPagesArgs } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = QueryHubspotIntegrationPagesArgs;
type TData = Page;

export const useHubSpotIntegrationGetPageMutation = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query hubspotIntegrationPages(
      $pageId: ID
      $pageType: HubspotPageTypeEnum
      $query: String
      $page: Int
      $perPage: Int
    ) {
      hubspotIntegrationPages(
        pageId: $pageId
        pageType: $pageType
        page: $page
        perPage: $perPage
        query: $query
      ) {
        nodes {
          pageId
          pageType
          jsonContent
        }
        hasNextPage
        nodesCount
        pagesCount
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: async (variables: TVariables): Promise<TData> =>
      (
        (await client.request({
          data: {
            gql: graphql,
            variables
          }
        })) as HubspotPagePage
      ).nodes
        ?.map((item) => JSON.parse(item.jsonContent))
        ?.at(0),
    ...options
  });
};
